// create long title for event/moment
export const getShortTitle = event =>
  event?.moment?.short_title ?? event?.short_title ?? "";

export const getTitle = event => event?.moment?.title ?? event?.title ?? "---";
